/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Meta_Ogdescription1Inputs */

const ja_contact_meta_ogdescription1 = /** @type {(inputs: Contact_Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームマーケティング、eスポーツ制作、クリエイティブ、インフルエンサーマーケティング、イベント制作、パートナーシップのご相談はお気軽にお問い合わせください。「株式会社プレイブレーン（PLAYBRAIN）」は日本・韓国・台湾をはじめとするアジア市場への展開に加え、日本企業の欧米市場向けマーケティングもサポートしています。`)
};

const en_contact_meta_ogdescription1 = /** @type {(inputs: Contact_Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact PLAYBRAIN to discuss game marketing, esports production, creative campaigns, influencer marketing, events, or business partnerships. We help game publishers and gaming brands succeed in Japan, South Korea, Taiwan, and across Asia.`)
};

/**
* | output |
* | --- |
* | "Contact PLAYBRAIN to discuss game marketing, esports production, creative campaigns, influencer marketing, events, or business partnerships. We help game pub..." |
*
* @param {Contact_Meta_Ogdescription1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_meta_ogdescription1 = /** @type {((inputs?: Contact_Meta_Ogdescription1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Meta_Ogdescription1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_meta_ogdescription1(inputs)
	return en_contact_meta_ogdescription1(inputs)
});
export { contact_meta_ogdescription1 as "contact_meta_ogDescription" }